module.exports = __webpack_public_path__ + "46a8a80d667671824a39518b2874912b.svg";